import { Component } from 'react';

class CreateFolderIcon extends Component {
  render() {
    return (
      <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M4.00739 9C4.00739 8.58579 4.34317 8.25 4.75739 8.25H8.25V4.75735C8.25 4.34314 8.58579 4.00735 9 4.00735C9.41421 4.00735 9.75 4.34314 9.75 4.75735V8.25H13.2427C13.6569 8.25 13.9927 8.58579 13.9927 9C13.9927 9.41421 13.6569 9.75 13.2427 9.75H9.75V13.2426C9.75 13.6569 9.41421 13.9926 9 13.9926C8.58579 13.9926 8.25 13.6569 8.25 13.2426V9.75H4.75739C4.34317 9.75 4.00739 9.41421 4.00739 9Z'
          fill='#65B0F2'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.31673 0.768758C7.40429 0.423679 10.5957 0.423679 13.6832 0.768758C15.5096 0.972883 16.9845 2.41153 17.1994 4.24849C17.5686 7.40541 17.5686 10.5946 17.1994 13.7515C16.9845 15.5885 15.5096 17.0271 13.6832 17.2313C10.5957 17.5763 7.40429 17.5763 4.31673 17.2313C2.49035 17.0271 1.01545 15.5885 0.800605 13.7515C0.431374 10.5946 0.431374 7.40541 0.800605 4.24849C1.01545 2.41153 2.49035 0.972883 4.31673 0.768758ZM13.5166 2.25948C10.5398 1.92677 7.46017 1.92677 4.48334 2.25948C3.33891 2.38738 2.42286 3.29063 2.29045 4.42274C1.93476 7.46389 1.93476 10.5361 2.29045 13.5773C2.42286 14.7094 3.33891 15.6126 4.48334 15.7405C7.46017 16.0732 10.5398 16.0732 13.5166 15.7405C14.6611 15.6126 15.5771 14.7094 15.7095 13.5773C16.0652 10.5361 16.0652 7.46389 15.7095 4.42274C15.5771 3.29063 14.6611 2.38738 13.5166 2.25948Z'
          fill='#65B0F2'
        />
      </svg>
    );
  }
}

export default CreateFolderIcon;
